export default "__VITE_ASSET__DRfkFLCL__"